import { Injectable, Output, EventEmitter, Directive } from '@angular/core';

@Directive()
@Injectable({
    providedIn: 'root'
})
export class StartWatchIdleTimer {
    // this service emits when dynamic parameters api hits and we get the data for auto session logout time
    @Output() startWatchIdleTimer: EventEmitter<any> = new EventEmitter();

    constructor() { }



    emitStartWatchIdleTimer() {
        this.startWatchIdleTimer.emit();
    }


}
